import { BaseComponent } from '../../base-component';
import { waitForAllPreloadedScriptsToBeLoaded } from '../../_common/client/otto-preloaded-scripts-helper';
import { OnlineMarketingData } from '../server';

export class OnlineMarketingComponent extends BaseComponent {
    public rootSelector = '.js_pdp_online-marketing';

    private isInitialVariationChange = true;

    public async init(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        // Since exactag calls the registered data provider callbacks directly after
        // o_global.eventLoader.onAllScriptsExecuted(), lhotse.exactag.register() must already be called in init(). For
        // our business it is ok that usually the reference variation and sometimes the seen variation is sent to exactag
        const onlineMarketingData = this.getOnlineMarketingData();
        OnlineMarketingComponent.registerExactagDataProviderCallback(onlineMarketingData);
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        if (this.isInitialVariationChange) {
            this.isInitialVariationChange = false;
            const onlineMarketingData = this.getOnlineMarketingData();
            OnlineMarketingComponent.trackFirebase(onlineMarketingData);
            await OnlineMarketingComponent.trackAdjust(onlineMarketingData);
        }
    }

    private getOnlineMarketingData(): OnlineMarketingData {
        return JSON.parse(this.getChildElement('.js_pdp_online-marketing__dataJson').innerHTML);
    }

    private static registerExactagDataProviderCallback(onlineMarketingData: OnlineMarketingData) {
        try {
            lhotse?.exactag?.register('productDetailPage', () => {
                const pb = onlineMarketingData.averageRatingRounded
                    ? String(onlineMarketingData.averageRatingRounded)?.replace('.', ',')
                    : undefined;
                return {
                    pt: 'Artikeldetailseite',
                    mp: onlineMarketingData.articleNumber,
                    mv: onlineMarketingData.variationId,
                    pr: onlineMarketingData.isSale ? 1 : 0,
                    pb,
                };
            });
        } catch (ignore) {
            // do nothing
        }
    }

    private static async trackAdjust(onlineMarketingData: OnlineMarketingData) {
        await waitForAllPreloadedScriptsToBeLoaded();
        if (window.o_apps && o_apps?.trackAdjust) {
            o_apps.trackAdjust({
                eventName: {
                    android: 'afdtak',
                    ios: 'xm6d1x',
                },
                partnerParameters: {
                    articleids: '["' + onlineMarketingData.articleNumber + '"]',
                    contentType: 'product',
                    sitePath: window.location.href,
                },
            });
        }
    }

    private static trackFirebase(onlineMarketingData: OnlineMarketingData) {
        o_global.eventQBus.emit('ft-apps.firebase.eventTracking', {
            event_name: 'view_item',
            event_params: {
                item_id: onlineMarketingData.articleNumber,
                item_name: onlineMarketingData.name,
                item_category: onlineMarketingData.businessCategory,
            },
        });
    }
}
